import ApiService from "./api.service";

class MeetingService extends ApiService {
    groups(ses) {
        return this.get(`Group/groups/${ses}`);
    }
    groupsForVoting(sessionId) {
        return this.get(`Group/getGroupsForVoting/${sessionId}`);
    }
    sessions() {
        return this.get("api/meeting");
    }
    getArchiveSessions() {
        return this.get("api/meeting/archive");
    }
    getSessionWithPointsById(id) {
        return this.get(`api/meeting/${id}/with-points`);
    }
    getSessionById(id) {
        return this.get(`api/meeting/${id}`);
    }
    updateSession(id, data) {
        return this.post(`api/meeting/${id}`, data);
    }
    removeSession(id) {
        return this.delete(`api/meeting/${id}`);
    }
    add(data) {
        return this.post("api/meeting", data);
    }

    addByTemplate(id, data) {
        return this.post(`api/meeting/templates/${id}/add-session`, data)
    }


    // niepotrzebne - zrobiono po filtracji wszystkich pobranych na poczatku
    //sessionsToday() {
    //    return this.post("/sessions/today");
    //}
    //sessionsTomorrow() {
    //    return this.post("/sessions/tomorrow");
    //}
    //sessionsThisWeek() {
    //    return this.post("/sessions/this-week");
    //}
    //sessionsThisMonth() {
    //    return this.post("/sessions/this-month");
    //}
}

export default new MeetingService();
